import { grey } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    buttonHover: Palette["primary"];
    darkGrey: Palette["primary"];
    lightGrey: Palette["primary"];
    myWhite: Palette["primary"];
    gray1: Palette["primary"];
    gray2: Palette["primary"];
    gray3: Palette["primary"];
    otherElementsBackground: Palette["primary"];
    leftMenuBackground: Palette["primary"];
    secondaryElementsBackground: Palette["primary"];
    contrastText: Palette["primary"];
    reverseContrastText: Palette["primary"];
    contrastIcon: Palette["primary"];
    defaultSideText: Palette["primary"];
    secondaryContrast: Palette["primary"];
    contrastTextWrapper: Palette["primary"];
    separator: Palette["primary"];

    tooltipBackground: Palette["primary"];
    tooltipText: Palette["primary"];

    tableRowTitle: Palette["primary"];
    tableRowIcon: Palette["primary"];

    attachmentsBackground: Palette["primary"];

    alertInfo: Palette["primary"];
    alertError: Palette["primary"];
    alertSuccess: Palette["primary"];
    alertWarning: Palette["primary"];

    emailBackground: Palette["primary"];
    contrastEmailText: Palette["primary"];
    contrastEmailWrapper: Palette["primary"];
    emailSeparator: Palette["primary"];

    inputLabelDisabled: Palette["primary"];
    secondaryTextDisabled: Palette["primary"];
    placeholder: Palette["primary"];
    tableDataRow: Palette["primary"];
    paymentName: Palette["primary"];
    autofillBackground: Palette["primary"];

    disabledText: Palette["primary"];
    chipBackground: Palette["primary"];
  }

  interface PaletteOptions {
    buttonHover: PaletteOptions["primary"];
    darkGrey: PaletteOptions["primary"];
    lightGrey: PaletteOptions["primary"];
    myWhite: PaletteOptions["primary"];
    gray1: PaletteOptions["primary"];
    gray2: PaletteOptions["primary"];
    gray3: PaletteOptions["primary"];
    otherElementsBackground: PaletteOptions["primary"];
    leftMenuBackground: PaletteOptions["primary"];
    secondaryElementsBackground: PaletteOptions["primary"];
    contrastText: PaletteOptions["primary"];
    reverseContrastText: PaletteOptions["primary"];
    contrastIcon: PaletteOptions["primary"];
    defaultSideText: PaletteOptions["primary"];
    secondaryContrast: PaletteOptions["primary"];
    contrastTextWrapper: PaletteOptions["primary"];
    separator: PaletteOptions["primary"];

    tooltipBackground: PaletteOptions["primary"];
    tooltipText: PaletteOptions["primary"];

    tableRowTitle: PaletteOptions["primary"];
    tableRowIcon: PaletteOptions["primary"];

    attachmentsBackground: PaletteOptions["primary"];

    alertInfo: PaletteOptions["primary"];
    alertError: PaletteOptions["primary"];
    alertSuccess: PaletteOptions["primary"];
    alertWarning: PaletteOptions["primary"];

    emailBackground: PaletteOptions["primary"];
    contrastEmailText: PaletteOptions["primary"];
    contrastEmailWrapper: PaletteOptions["primary"];
    emailSeparator: PaletteOptions["primary"];

    inputLabelDisabled: PaletteOptions["primary"];
    secondaryTextDisabled: PaletteOptions["primary"];
    placeholder: PaletteOptions["primary"];
    tableDataRow: PaletteOptions["primary"];
    paymentName: PaletteOptions["primary"];
    autofillBackground: PaletteOptions["primary"];

    disabledText: PaletteOptions["primary"];
    chipBackground: PaletteOptions["primary"];
  }
}

export const defaultDarkOtherElements = "#2A2C38";
export const defaultLightOtherElements = "#FFFFFF";
export const defaultLightEmailBackground = "#F8F9FA";

export const defaultDarkLeftMenu = "#27292E";
export const defaultLightLeftMenu = "#FFFFFF";

export const defaultLightContrastText = "#000000";
export const defaultDarkContrastText = "#FFFFFF";

export const defaultLightReverseContrastText = "#333";
export const defaultDarkReverseContrastText = "#000";

export const defaultSideText = "#9E9E9E";

export const defaultDarkContrastTextWrapper = "rgba(39, 41, 46, 0.40)";
export const defaultLightContrastTextWrapper = "rgba(255, 255, 255, 0.40)";

export const defaultLightSeparator = "#E0E0E0";
export const defaultDarkSeparator = "#4F4F4F";

export const defaultLightIcon = grey[600];
export const defaultDarkIcon = "rgba(255, 255, 255, 0.20)";

export const defaultLightSecondaryElementsBackground = "#616161";
export const defaultDarkSecondaryElementsBackground = "#E0E0E0";

export const defaultLightSecondaryContrast = "#E0E0E0";
export const defaultDarkSecondaryContrast = "#828282";

export const defaultLightAlertError = "#FFEBEE";
export const defaultDarkAlertError = "rgba(242, 139, 130, 0.25)";

export const defaultLightAlertInfo = "#E3F2FD";
export const defaultDarkAlertInfo = "rgba(41, 121, 255, 0.25)";

export const defaultLightAlertWarning = "rgb(255, 244, 229)";
export const defaultDarkAlertWarning = "rgba(235, 180, 99, 0.25)";

export const defaultLightAlertSuccess = "#E8F5E9";
export const defaultDarkAlertSuccess = "rgba(129, 201, 149, 0.25)";

export const defaultLightTooltipBackground = "#616161";
export const defaultDarkTooltipBackground = "#E0E0E0";

export const defaultLightTooltipText = "#FFF";
export const defaultDarkTooltipText = "#333";

export const defaultLightTableRowTitle = "#9E9E9E";
export const defaultDarkTableRowTitle = "#828282";

export const defaultLightTableRowIcon = grey[600];
export const defaultDarkTableRowIcon = "#9E9E9E";

export const defaultDarkAttachmentsBackground = "#23282F";
export const defaultLightAttachmentsBackground = "#FAFAFA";

export const defaultLightContrastEmailText = "#000000";
export const defaultDarkContrastEmailText = grey[400];

export const defaultDarkContrastEmailWrapper = "#000000";
export const defaultLightContrastEmailWrapper = grey[100];

export const defaultDarkEmailSeparator = "#353535";
export const defaultLightEmailSeparator = "#f5f5f5";

export const defaultLightDisabledInputLabel = "#000000";
export const defaultDarkDisabledInputLabel = grey[600];

export const defaultLightDisabledSecondaryText = grey[500];
export const defaultDarkDisabledSecondaryText = "#ffffff";

export const defaultLightPlaceholder = "#9E9E9E";
export const defaultDarkPlaceholder = "#828282";

export const defaultLightTableDataRow = "#757575";
export const defaultDarkTableDataRow = "#828282";

export const defaultLightPaymentName = grey[500];
export const defaultDarkPaymentName = grey[400];

export const defaultLightAutofillBackground = "#E3F2FD";
export const defaultDarkAutofillBackground = "#273752";

export const defaultLightDisabledButtonBackground = "#E0E0E0";
export const defaultDarkDisabledButtonBackground = "#4F4F4F";

export const defaultLightDisabledButtonText = "#9E9E9E";
export const defaultDarkDisabledButtonText = "#828282";

export const defaultLightDisabledText = "rgba(0, 0, 0, 0.38)";
export const defaultDarkDisabledText = "#9E9E9E";

export const defaultLightChipBackground = "#FFFFFF";
export const defaultDarkChipBackground = "#2A2C38";

const themeFields = {
  spacing: 8,
  typography: {
    h2: {
      fontSize: "24px",
      lineHeight: "36px",
    },
    h3: {
      fontSize: "16px",
      fontWeight: 500,
    },
    h4: {
      fontSize: "14px",
      fontWeight: 400,
    },
    h5: {
      fontSize: "12px",
    },
    subtitle1: {
      fontSize: "28px",
      lineHeight: "28px",
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: "21px",
      lineHeight: "25.2px",
      fontWeight: 400,
    },
    button: {
      fontSize: "14px",
      fontWeight: 600,
    },
  },
  palette: {
    action: {
      disabled: defaultLightDisabledButtonText,
      disabledBackground: defaultLightDisabledButtonBackground,
    },
    primary: {
      main: "#2979ff", // blue.A400
    },
    secondary: {
      main: "#e3f2fd", // blue[50]
    },
    buttonHover: {
      main: "#194999",
    },
    darkGrey: {
      main: "#808080",
    },
    lightGrey: {
      main: "#ECECEC",
    },
    success: {
      main: "#4CAF50", // green[500]
    },
    error: {
      main: "#F44336", // red[500]
    },
    warning: {
      main: "#FF9800", // orange[500]
    },
    myWhite: {
      main: "#FF0FFF",
    },
    gray1: {
      main: "rgba(0, 0, 0, 0.15);",
    },
    gray2: {
      main: "rgba(0, 0, 0, 0.4)",
    },
    gray3: {
      main: "rgba(0, 0, 0, 0.6)",
    },
    otherElementsBackground: {
      main: "#FFFFFF",
    },
    leftMenuBackground: {
      main: defaultLightLeftMenu,
    },
    contrastText: {
      main: "#424242",
    },
    contrastIcon: {
      main: "rgb(117, 117, 117)",
    },
    defaultSideText: {
      main: defaultSideText,
    },
    contrastTextWrapper: {
      main: defaultLightContrastText,
    },
    separator: {
      main: defaultLightSeparator,
    },
    secondaryElementsBackground: {
      main: defaultLightSecondaryElementsBackground,
    },
    reverseContrastText: {
      main: defaultLightReverseContrastText,
    },
    tooltipBackground: {
      main: defaultLightTooltipBackground,
    },
    tooltipText: {
      main: defaultLightTooltipText,
    },
    secondaryContrast: {
      main: defaultLightSecondaryContrast,
    },
    alertError: {
      main: defaultLightAlertError,
    },
    alertInfo: {
      main: defaultLightAlertInfo,
    },
    alertSuccess: {
      main: defaultLightAlertSuccess,
    },
    alertWarning: {
      main: defaultLightAlertWarning,
    },
    tableRowTitle: {
      main: defaultLightTableRowTitle,
    },
    tableRowIcon: {
      main: defaultLightTableRowIcon,
    },
    attachmentsBackground: {
      main: defaultLightAttachmentsBackground,
    },
    contrastEmailText: {
      main: defaultLightContrastEmailText,
    },
    contrastEmailWrapper: {
      main: defaultLightContrastEmailWrapper,
    },
    emailSeparator: {
      main: defaultLightEmailSeparator,
    },
    emailBackground: {
      main: defaultLightEmailBackground,
    },
    inputLabelDisabled: {
      main: defaultLightDisabledInputLabel,
    },
    secondaryTextDisabled: {
      main: defaultLightDisabledSecondaryText,
    },
    placeholder: {
      main: defaultLightPlaceholder,
    },
    tableDataRow: {
      main: defaultLightTableDataRow,
    },
    paymentName: {
      main: defaultLightPaymentName,
    },
    autofillBackground: {
      main: defaultLightAutofillBackground,
    },
    disabledText: {
      main: defaultLightDisabledText,
    },
    chipBackground: {
      main: defaultLightChipBackground,
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        html: {
          overflowY: "scroll" as const,
        },
      },
    },
    MuiTableRow: {
      root: {
        "&:last-child td": {
          borderBottom: 0,
        },
      },
    },
  },
};
const theme = createMuiTheme(themeFields);

export const createCustomTheme = (
  primaryColor: string,
  secondaryColor: string
) =>
  createMuiTheme({
    ...themeFields,
    palette: {
      ...themeFields.palette,
      primary: { main: primaryColor },
      secondary: { main: secondaryColor },
    },
  });

type CreateExhibitorThemeArgs = {
  primaryColor: string;
  secondaryColor: string;
  otherElementsBackground: string;
  leftMenuBackground: string;
  contrastText: string;
  contrastTextWrapper: string;
  separator: string;
  contrastIcon: string;
  secondaryElementsBackground: string;
  reverseContrastText: string;
  secondaryContrast: string;
  alertInfo: string;
  alertError: string;
  alertSuccess: string;
  alertWarning: string;
  tooltipBackground: string;
  tooltipText: string;
  tableRowTitle: string;
  tableRowIcon: string;
  attachmentsBackground: string;
  contrastEmailText: string;
  contrastEmailWrapper: string;
  emailSeparator: string;
  emailBackground: string;
  inputLabelDisabled: string;
  secondaryTextDisabled: string;
  placeholder: string;
  tableDataRow: string;
  paymentName: string;
  autofillBackground: string;
  disabledButtonBackground: string;
  disabledButtonText: string;
  disabledText: string;
  chipBackground: string;
};

export const createExhibitorTheme = ({
  primaryColor,
  secondaryContrast,
  secondaryColor,
  otherElementsBackground,
  leftMenuBackground,
  contrastText,
  contrastTextWrapper,
  separator,
  contrastIcon,
  secondaryElementsBackground,
  reverseContrastText,
  alertError,
  alertInfo,
  alertSuccess,
  alertWarning,
  tooltipBackground,
  tooltipText,
  tableRowTitle,
  tableRowIcon,
  attachmentsBackground,
  contrastEmailText,
  contrastEmailWrapper,
  emailSeparator,
  emailBackground,
  inputLabelDisabled,
  secondaryTextDisabled,
  placeholder,
  tableDataRow,
  paymentName,
  autofillBackground,
  disabledButtonBackground,
  disabledButtonText,
  disabledText,
  chipBackground,
}: CreateExhibitorThemeArgs) =>
  createMuiTheme({
    ...themeFields,
    palette: {
      ...themeFields.palette,
      primary: { main: primaryColor },
      secondary: { main: secondaryColor },
      otherElementsBackground: { main: otherElementsBackground },
      leftMenuBackground: { main: leftMenuBackground },
      contrastText: { main: contrastText },
      contrastTextWrapper: { main: contrastTextWrapper },
      separator: { main: separator },
      contrastIcon: { main: contrastIcon },
      secondaryElementsBackground: { main: secondaryElementsBackground },
      reverseContrastText: { main: reverseContrastText },
      secondaryContrast: { main: secondaryContrast },
      alertError: { main: alertError },
      alertInfo: { main: alertInfo },
      alertSuccess: { main: alertSuccess },
      alertWarning: { main: alertWarning },
      tooltipBackground: { main: tooltipBackground },
      tooltipText: { main: tooltipText },
      tableRowTitle: { main: tableRowTitle },
      tableRowIcon: { main: tableRowIcon },
      attachmentsBackground: { main: attachmentsBackground },
      contrastEmailText: { main: contrastEmailText },
      contrastEmailWrapper: { main: contrastEmailWrapper },
      emailSeparator: { main: emailSeparator },
      emailBackground: { main: emailBackground },
      inputLabelDisabled: { main: inputLabelDisabled },
      secondaryTextDisabled: { main: secondaryTextDisabled },
      placeholder: { main: placeholder },
      tableDataRow: { main: tableDataRow },
      paymentName: { main: paymentName },
      autofillBackground: { main: autofillBackground },
      action: {
        disabled: disabledButtonText,
        disabledBackground: disabledButtonBackground,
      },
      disabledText: {
        main: disabledText,
      },
      chipBackground: {
        main: chipBackground,
      },
    },
  });

export default theme;
export type themeType = typeof theme;
